import(/* webpackMode: "eager" */ "/home/circleci/whoop-web/apps/shop/app/global-error.tsx");
